import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { Metric } from "../../metric";
import { Mapper } from "../Mapper/Mapper";
import styles from "./styles.pcss";
import { connector } from "./connector";
var cx = classNames.bind(styles);
export var _LinksBlock = function _LinksBlock(_ref) {
  var links = _ref.links;
  return /*#__PURE__*/React.createElement("nav", {
    className: cx('grid__container'),
    "data-t-id": "components-LinksBlock"
  }, /*#__PURE__*/React.createElement(Mapper, {
    items: links
  }, function (linksRow, index) {
    return /*#__PURE__*/React.createElement("ul", {
      className: cx('column', index === 1 && 'column-margin'),
      key: index
    }, /*#__PURE__*/React.createElement(Mapper, {
      items: linksRow.items
    }, function (item) {
      return /*#__PURE__*/React.createElement("li", {
        key: item.title
      }, /*#__PURE__*/React.createElement(Metric, {
        asChild: true,
        data: JSON.stringify({
          link_text: item.title,
          link_url: item.href
        }),
        events: {
          footerMetric: ['handleClickLink']
        },
        mode: "click"
      }, /*#__PURE__*/React.createElement(Text, {
        className: cx('grid__item'),
        href: item.href,
        tagName: "a",
        variant: linksRow.size === 'xs' ? 'body-small' : 'body-medium',
        "data-t-id": "components-LinksBlock"
      }, item.title)));
    }));
  }));
};
export var LinksBlock = connector(_LinksBlock);